/**
 * «Pin til dashboard» fra Spør Compass: pinnen legges i kø i sessionStorage og hentes av DashboardProvider.
 * Tidligere ble bare en window-hendelse sendt — den gikk tapt når dashboardet ikke var montert (bare én modul
 * vises om gangen), så rapporten ble laget, men widgeten ble aldri lagt til.
 */
export interface PendingPin {
    reportId: number;
    displayMode: string;
    title?: string;
}

const KEY = 'compass.pendingPins';

export function queuePin(pin: PendingPin): void {
    try {
        const list: PendingPin[] = JSON.parse(sessionStorage.getItem(KEY) || '[]');
        list.push(pin);
        sessionStorage.setItem(KEY, JSON.stringify(list.slice(-10)));
    } catch {
        // sessionStorage utilgjengelig: hendelsen nedenfor dekker tilfellet der dashboardet er montert
    }
    window.dispatchEvent(new CustomEvent('compass-pin-to-dashboard', { detail: pin }));
}

/** Henter og tømmer køen (kalles av dashboardet ved montering og ved hendelsen). */
export function takePendingPins(): PendingPin[] {
    try {
        const list: PendingPin[] = JSON.parse(sessionStorage.getItem(KEY) || '[]');
        sessionStorage.removeItem(KEY);
        return Array.isArray(list) ? list.filter(p => typeof p?.reportId === 'number') : [];
    } catch {
        return [];
    }
}
